var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "collection-sections" },
    [
      _vm.collectionSections.settings.enableBanner === 1
        ? _c("collection-banner", {
            attrs: { banner: _vm.collectionSections.banner }
          })
        : _vm._e(),
      _vm.collectionSections.settings.enableCategoryImages === 1
        ? _c("collection-category-images", {
            attrs: { "category-images": _vm.collectionSections.categoryImages }
          })
        : _vm._e(),
      _vm.collectionSections.settings.enableCategoryLinks === 1
        ? _c("collection-category-links", {
            attrs: { "category-links": _vm.collectionSections.categoryLinks }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }